var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Uncompleteorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-_uncomplete_order",
    "data-name": "icon-24- uncomplete order",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7092",
    "data-name": "Rectangle 7092",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "purchase-order-icon",
    transform: "translate(3.667 1.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M3.735,3.123h5.92c.42,0,.4.17.361.6l-.238,3.05c-.041.485-.007.368-.521.442l-4.22.369.25.727H9.87c.07.259.163.677.231.965H9.256l-.082-.294H5.614c-.934-.015-.841.237-1.064-.57l-1.6-5.48h-.5V2.253H3.526c.063.237.151.631.209.87ZM11.6.112A.435.435,0,0,0,11.317,0a.237.237,0,0,0-.068.007H.943A.947.947,0,0,0,.277.284.932.932,0,0,0,0,.95V19.968a.947.947,0,0,0,.943.943H15.707a.947.947,0,0,0,.943-.943V5.5a.563.563,0,0,0,.015-.106.453.453,0,0,0-.143-.322L11.652.141a.148.148,0,0,0-.037-.031l-.014,0Zm-.335.74V4.164a1.278,1.278,0,0,0,1.28,1.28h3.244V19.97a.08.08,0,0,1-.031.068.1.1,0,0,1-.068.031H.934a.08.08,0,0,1-.068-.031.11.11,0,0,1-.031-.068V.95A.071.071,0,0,1,.866.882.1.1,0,0,1,.934.851H11.266v0Zm.844,3.312V1.526L15.137,4.6H12.544a.455.455,0,0,1-.306-.128.442.442,0,0,1-.128-.306Zm-8.618,7.7a.426.426,0,0,0,0,.853h9.552a.426.426,0,1,0,0-.853Zm.16,5.052a.426.426,0,1,0,0,.853h9.489a.426.426,0,1,0,0-.853Zm-.16-2.437a.425.425,0,0,0,0,.851h9.649a.425.425,0,0,0,0-.851ZM6.3,3.892H7.52V5.134h1.1L6.909,6.8,5.2,5.132H6.3V3.892ZM5.621,9.4a.653.653,0,1,1-.653.653A.654.654,0,0,1,5.621,9.4Zm2.694,0a.653.653,0,1,1-.653.653A.654.654,0,0,1,8.315,9.4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Uncompleteorder);
export default __webpack_public_path__ + "static/media/icon-24- uncomplete order.984147522e6c16fd8c7179c2b0752b81.svg";
export { ForwardRef as ReactComponent };